import { render, staticRenderFns } from "./LeaderboardComparison.vue?vue&type=template&id=16027ae9&scoped=true&"
import script from "./LeaderboardComparison.vue?vue&type=script&lang=js&"
export * from "./LeaderboardComparison.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardComparison.vue?vue&type=style&index=0&id=16027ae9&scoped=true&lang=css&"
import style1 from "./LeaderboardComparison.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16027ae9",
  null
  
)

export default component.exports